/**
 * For signing any payload by using the account keyring.
Signing the public keys of an account creates a trust-chain that other accounts can save with a simple
fingerprint to verify the trust.
Signing a group-encrypted message ensures the poster's identity.
 */

import { CryptoContext } from '../base';
import { AccountSignatureConfigDumpArgs, AccountSignatureConfigLoadArgs } from './args';
import { AccountSignatureConfigV1 } from './v1';
import { AccountSignatureConfigV2 } from './v2';
import { CU_ANNULLED_BY_PQC_ML, CU_PQC_ML } from '../feature';

export let ACCOUNT_SIGNATURE_CRYPTO_CONTEXT = new CryptoContext<
  AccountSignatureConfigLoadArgs,
  AccountSignatureConfigDumpArgs
>(
  [new AccountSignatureConfigV1(CU_ANNULLED_BY_PQC_ML), new AccountSignatureConfigV2(CU_PQC_ML)],
  [new Uint8Array([1])]
);
